import React from "react";

import * as typography from "@client/shared/typography";

import * as components from "@client/site/components";
import * as forms from "@client/site/forms";
import {server} from "@reactivated";

export const Template = (props: server.core.templates.LeadImport) => (
    <components.Layout title={props.title}>
        <typography.Header>{props.title}</typography.Header>
        <typography.P>Use this tool to process leads.</typography.P>
        <form
            noValidate
            method="POST"
            action=""
            className="flex flex-col space-y-[15px]"
            encType="multipart/form-data"
        >
            <forms.CSRFToken />
            <forms.Fields form={props.upload_csv_form} />
            <typography.Button submit name="upload">
                Upload
            </typography.Button>
            {props.form_set.forms.length > 0 && (
                <>
                    <forms.FormSet formSet={props.form_set} />
                    <typography.Button submit name="submit">
                        Submit
                    </typography.Button>
                </>
            )}
        </form>
    </components.Layout>
);
